import { Alert } from '@cmsgov/ds-medicare-gov'
import { ContentLayout } from 'components/Layouts'
import { MyLink } from 'components/MyLink'
import { Trans, useTranslation } from 'react-i18next'

function ChangeSubscriptionsLink ({ children }: any) {
  return (
    <MyLink href="https://public.govdelivery.com/accounts/USCMSMYMEDICARE/subscriber/new">
      {children}
    </MyLink>
  )
}

export function DeleteAccountSuccessPage () {
  const { t } = useTranslation('deleteAccount')

  return (
    <ContentLayout heading={t('heading')} width="wide">
      <div className="ds-l-container">
        <Alert
          variation="success"
          heading={t('success.alert.heading')}
          className="ds-u-measure--wide"
        >
          <Trans
            t={t}
            i18nKey={'success.alert.content'}
            components={{
              link1: <ChangeSubscriptionsLink />
            }}
          />
        </Alert>

        <div className="ds-u-margin-top--4">
          <MyLink href="/" className="ds-c-button ds-c-button--solid">
            {t('success.close')}
          </MyLink>
        </div>
      </div>
    </ContentLayout>
  )
}
